import { render, staticRenderFns } from "./globe.vue?vue&type=template&id=2c4e8458"
import script from "./globe.vue?vue&type=script&lang=js"
export * from "./globe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports